import { nanoid } from "nanoid";

/** Sync ids in the browser. Server code uses `generateIdAsync` in `node/util/nanoid.ts`. */
export const generateId = (size?: number): string => nanoid(size);
